export default {"src":"/_next/static/media/pool-nudge.77d293ca.svg","height":195,"width":195,"blurWidth":0,"blurHeight":0};